// Per-user voice preferences persisted server-side. Currently just the
// transcription language — the picker in the voice modal reads/writes here.
// Backed by GET/PATCH /user/voice-language on the API.

import nodeAPI from "../../../service/ApiServiceNode";
import logger from "../../../utils/logger";

export const SUPPORTED_LANGUAGES = [
    { code: "en", label: "English" },
    { code: "fr", label: "Français" },
    { code: "es", label: "Español" },
    { code: "id", label: "Bahasa Indonesia" },
    { code: "zh", label: "中文" },
    { code: "de", label: "Deutsch" },
    { code: "it", label: "Italiano" },
    { code: "pt", label: "Português" },
    { code: "ja", label: "日本語" }
];

export const DEFAULT_LANGUAGE = "en";

export async function fetchVoiceLanguage() {
    try {
        const res = await nodeAPI.get("/user/voice-language");
        const data = res?.data?.data ?? res?.data ?? {};
        return data.language || DEFAULT_LANGUAGE;
    } catch (err) {
        logger.error("[voice-prefs] failed to load language", err);
        return DEFAULT_LANGUAGE;
    }
}

export async function saveVoiceLanguage(language) {
    if (!SUPPORTED_LANGUAGES.some((l) => l.code === language)) return;
    try {
        await nodeAPI.patch("/user/voice-language", { language });
    } catch (err) {
        logger.error("[voice-prefs] failed to save language", err);
    }
}
